import { render } from "./PersonalLayout.vue?vue&type=template&id=73f7c1a5&scoped=true"
import script from "./PersonalLayout.vue?vue&type=script&lang=js"
export * from "./PersonalLayout.vue?vue&type=script&lang=js"

import "./PersonalLayout.vue?vue&type=style&index=0&id=73f7c1a5&scoped=true&lang=scss"

import exportComponent from "/var/www/www-root/data/www/malmarket/malmarket-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f7c1a5"]])

export default __exports__